import * as React from "react";

export class GameClock extends React.Component<{ time: string, gameStatus: string }, {}> {

    render() {

        return (
            <div className="rj-sports-multiview__event-game-clock">
                {this.props.gameStatus !== "" && (<span className="rj-sports-multiview__event-game-status">{this.props.gameStatus}</span>)}
                {this.props.time !== "" && (<span className="rj-sports-multiview__event-game-time">{this.props.time}</span>)}
            </div>
        )
    }
}